import { getPortfolioAgreementDetail } from "@hp/api-client";
import type { PortfolioAgreementDetail } from "@hp/types";
import { USE_MOCK_DATA } from "./config";
import { simulateNetwork } from "./simulateNetwork";

export function fetchPortfolioAgreementDetail(agreementId: string): Promise<PortfolioAgreementDetail> {
  if (!USE_MOCK_DATA) return getPortfolioAgreementDetail(agreementId);
  return simulateNetwork({
    agreement: {
      id: agreementId,
      name: "Mock contract",
      counterparty: "DISCOM",
      forum: "state_commission",
      agreement_type: "cost_plus",
      effective_date: "2015-01-01",
      contracted_share: null,
      tariff_basis: null,
      share_basis_note: null,
      flagged_claim_count: 0,
      flagged_claim_value_high_total: 0,
      flagged_principal_value_high_total: 0,
      flagged_carrying_cost_value_high_total: 0,
      flagged_claim_avg_confidence: null,
      recovered_claim_count: 0,
      recovered_claim_value_high_total: 0,
      recovered_principal_value_high_total: 0,
      recovered_carrying_cost_value_high_total: 0,
      recovered_claim_avg_confidence: null,
      portfolio_pipeline_status: "none",
      processing_status: "placeholder",
      source_pdf: null,
    },
    processing_status: "placeholder",
    source_pdf: null,
    clause_count: 0,
    line_item_count: 0,
    tax_position_count: 0,
    gap_count: 0,
    unclaimed_gap_count: 0,
    unclaimed_gap_value_high: 0,
    open_claims_principal_high_total: 0,
    open_claims_carrying_cost_high_total: 0,
    open_claims_value_high_total: 0,
    clauses: [],
    gaps: [],
    line_items: [],
    open_claims: [],
    next_steps: ["Mock data — connect to the API for live portfolio detail."],
    can_surface_potential_claims: false,
    potential_claims_note: "Potential claims are unavailable in mock mode.",
  });
}
